import { API } from "./apiClient";
import { API_USER_EVENTS_AGGREGATION } from "../../constants";

const API_NAME = API_USER_EVENTS_AGGREGATION;
const EVENTS_PATH = "/events";

/**
 * Fetch aggregated events for operators
 * @param {Object} options - Query options
 * @param {number} options.limit - Max number of events to return (default: 100)
 * @param {string} options.nextToken - Pagination token from previous request
 * @param {string} options.eventType - Filter by event type (match, assignment, note, group_match)
 * @returns {Promise<Object>} { events: [...], nextToken, count }
 */
export async function listAggregatedEvents(options = {}) {
  try {
    const queryParams = {};

    if (options.limit) queryParams.limit = options.limit;
    if (options.nextToken) queryParams.nextToken = options.nextToken;
    if (options.eventType) queryParams.eventType = options.eventType;

    const response = await API.get(API_NAME, EVENTS_PATH, {
      queryStringParameters: queryParams
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch aggregated events:", error);
    throw error;
  }
}
